import {
    Container,
    Icon
} from './styled';
import { IoIosSearch } from 'react-icons/io';

export function Search(props) {

    const { className, ref, ...restProps } = props;

    return (
        <Container className={className}>
            <Icon>
                <IoIosSearch />
            </Icon>
            <input {...restProps} ref={ref} />
        </Container>
    );
}